import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Spinner, Button } from 'react-bootstrap';
import { FaTimesCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const HOME_URL = 'https://fr.licorne-academy.com';

const PaymentFailedScreen = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const redirectTimeout = setTimeout(() => {
      window.location.href = HOME_URL;
    }, 8000);

    return () => clearTimeout(redirectTimeout);
  }, []);

  return (
    <div className='payment-status-page'>
      <div className='status-panel fail'>
        <img src='/licorne.png' alt='Licorne' className='status-brand-logo' />
        <div className='status-icon fail-icon'>
          <FaTimesCircle />
        </div>
        <h1>{t('payfail')}</h1>
        <p>
          {t('payment_failed_message') ||
            'Une erreur est survenue lors du traitement de votre paiement. Veuillez réessayer.'}
        </p>
        <Spinner animation='border' variant='danger' />
        <p className='status-redirect'>
          {t('redirecting') || 'Redirection en cours...'}
        </p>
        <div className='status-actions'>
          <Link to='/cart' className='btn btn-teal'>
            {t('returnCart') || 'Retour au panier'}
          </Link>
          <Button
            className='btn-outline-teal'
            onClick={() => (window.location.href = HOME_URL)}
          >
            {t('redirect_now') || 'Rediriger maintenant'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailedScreen;
